module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ashley-colasantos-44a8467a1d8fe152e98cf3605b67e831.jpg";